import { render, staticRenderFns } from "./MenuRemoveFormatButton.vue?vue&type=template&id=670f389a&"
import script from "./MenuRemoveFormatButton.vue?vue&type=script&lang=ts&"
export * from "./MenuRemoveFormatButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports